module.exports = __webpack_public_path__ + "static/media/hero.5a0c27df.png";